class SendInvoices {
    constructor(Alert, $http, locale, ResourceCommon) {
        this.key = 'send-invoices';
        this.title = 'Send Invoices';
        this.level = 'selected';
        this.alert = Alert;
        this.locale = locale;
        this.api = $http;
        this.resourceCommon = ResourceCommon;
    }

    action({}, store) {
        return this.resourceCommon.selectEmailTemplate(true, null).then((data) => {
            return this.locale.ready(['categories', 'sweetalerts'])
                .then(() => {
                    this.api.post('billing/invoices/send', {
                        invoices: store.getters.selectedFilters,
                        template_id: data.template.id,
                        attach_invoice: data.attach_invoice
                    }).then(() => {
                        store.dispatch('getData');
                        this.alert.success('Messages scheduled', 'The messages are getting sent now step by step');
                    }, err => this.alert.handle(err))
                });
        }, () => {

        });
    }
}

angular
    .module('festzelt-os.billing.invoices')
    .factory('sendInvoices', [
        'Alert',
        '$http',
        'locale',
        'ResourceCommon',
        (Alert, $http, locale, ResourceCommon) => new SendInvoices(Alert, $http, locale, ResourceCommon)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/send-invoices.js